import ContactService from '../../../../../services/contact_service';

const Contact = (vm) => {
  const updateContactBase = async () => {
    try {
      const payload = {
        PrincipalEmail: vm.formDataUser.email.trim(),
        AlternativeEmail: vm.formDataUser.alternativeEmail?.trim() || null,
        FirstName: vm.formDataUser.first_Name.trim(),
        LastName: vm.formDataUser.last_Name?.trim() || null,
        NumeroIdentificacion: vm.formDataUser.identificationNumber.trim(),
        Phone: vm.formDataUser.cellPhone?.trim() || null,
        Phone2: vm.formDataUser.phone?.trim() || null,
        Birthdate: vm.formDataUser.birthdate,
        UpdateNumber: vm.userlogin.UpdateNumber,
        FK_City: vm.formDataUser.cityId ? String(vm.formDataUser.cityId) : null,
        FK_Role: String(vm.formDataUser.role),
        FK_TypeId: String(vm.formDataUser.typeIdentificationNumber),
        FK_Country: String(vm.formDataUser.country),
        FK_Motivation: String(vm.formDataUser.motivation),
      };
      const userUp = await ContactService.update(vm.userlogin.Id, payload);
      if (vm.logout(userUp)) return { stopped: true };
      vm.setUser(userUp);
      vm.onBackToLogin(userUp);
      return {
        stopped: false,
        userUp,
      };
    } catch (e) {
      vm.message(e?.message || e, "error")
      return { stopped: true }
    }
  };

  return {
    updateContactBase,
  };
};

export default Contact;
